import Navbar from "../components/common/Navbar";
import AiHero from "../components/aiContentCreation/AiHero";
import AiFormats from "../components/aiContentCreation/AiFormats";
import AiWhy from "../components/aiContentCreation/AiWhy";
import AiProcess from "../components/aiContentCreation/AiProcess";
import AiCta from "../components/aiContentCreation/AiCta";
// Shares the Events & Experiences theme (type, buttons, section spacing).
// Scroll position on arrival is handled by MainLayout.
import "../styles/eventsExperiences.css";
import "../styles/aiContentCreation.css";

const AiContentCreationPage = () => (
  <div className="ee ai">
    <Navbar />
    <AiHero />
    <AiFormats />
    <AiWhy />
    <AiProcess />
    <AiCta />
  </div>
);

export default AiContentCreationPage;
